import postgresBackendService from '../services/postgresBackendService';

/**
 * #759 D20 — abrir por primera vez un agente que sumó una plantilla le quita el «Nuevo». Las
 * listas se enteran por el WebSocket (`role_builder_update` con `isNew: false`) que emite el
 * backend al marcarlo, también las de otras pestañas.
 *
 * Si la llamada falla, el agente vuelve a salir como nuevo en la próxima carga: es solo una marca.
 */
export function markAgentSeen(role) {
  if (!role?.isNew) return;
  postgresBackendService.markRolSeen(role.id).catch((err) => {
    console.warn('[markAgentSeen] no se pudo marcar el agente como visto:', err?.message);
  });
}
